import {createGUID} from "../../global/globalUtils";
import {OwayoKonfiPart} from "../owayoPartWithSelObs";
import {ChromoLogoColor, StockLogo, StockLogoFromBackend} from "../selectableObjects";
import {PartPattern} from "./partPattern";
import {EventVerteiler} from "../../global/eventVerteiler";
import {HandleShaderCreator, ShaderCreator} from "../shader/OwayoShader";
import {ColorUtils} from "../colorUtils";
import {Patternfarbgedaechtnis} from "../3dviewerModules/partPatternController";
import {PATTERN_EVENTNAMES} from "./patternFactory";
import {PlusMinus} from "./patternViewComponent";
import {StockLogoColorVersion, StockLogoColorVersionColor} from "./patternFarbVorschlaege";
import {CONSTANTS} from "../meta_data";
import {THREE} from "../resource/BVH.js";
import {Vector2} from "../delme_globals";
import {TaskCounter} from "../taskCounter";
import globalsObject from "../globalsObject";
import { Canvg } from "canvg"
import {PatternSizeSteps} from "./patternSizeSteps";
import {SelObTypes} from "../SelObTypes";
import {arrayElementByKeyValue} from "../../global/arrayHelper";
import {logIfDebug, warnIfDebug} from "../../global/logFunctions";


export class PatternAnker {
    public partname:string;
    public anker:Vector2;

    public constructor(partname:string, position:Vector2) {
        this.partname = partname;
        this.anker = position;
    }
}

export class PatternAnkerContainer {
    public anker:PatternAnker[] = [];

    public getPosition(partname) {
        const found = this.anker.filter(p=>p.partname === partname);
        if(found.length ===0) {
            warnIfDebug("no entry found in patternpostions for "+partname);
            return new Vector2(0.5, 0.5);
        }
        return found[0].anker;
    }

    public setPosition(partname, position:Vector2) {
        this.anker = this.anker.filter(p=>p.partname !==partname);
        this.anker.push(new PatternAnker(partname, position));
    }

    public extractAnkerFromParts(parts:OwayoKonfiPart[]) {// , loadedAncors:Resource|null) {
        // if(loadedAncors !== null) {
        //     this.anker = loadedAncors.resource;
        //     return;
        // }
        parts.forEach(p=>this.setPosition(p.name, p.patternAnker as Vector2));
    }
}

export class PartPatternContainer {

    public readonly forColorCodeNr: number;
    public readonly stockLogoID: number;
    private patternAnker:PatternAnkerContainer;

    private originalSVG=""
    private vorschauSVG =""
    public colors: ChromoLogoColor[];
    private patterns: PartPattern[] = [];
    private clonedPatterns : PartPattern[] = [];
    private insertTargetSize: number;
    public getInsertTargetSize = ()=>this.insertTargetSize;
    private sizes :{min, max, standard};
    private taskCounter: TaskCounter;
    private readonly getDroppableParts: () => OwayoKonfiPart[];
    private sizeStepsContainer:PatternSizeSteps;


    constructor(stockLogo: StockLogo, droppablePartGetter : ()=>OwayoKonfiPart[]) {
        const $this = this;
        globalsObject.stockLogoStore.getVorschauSVG(stockLogo.stockLogoID).then(
            function(svg){
                $this.vorschauSVG = svg
                $this.broadcastPreviewSVG();
            }
        );
        this.sizeStepsContainer = new PatternSizeSteps(stockLogo.minSizeCM, stockLogo.maxSizeCM, stockLogo.standardSizeCM);
        this.getDroppableParts = droppablePartGetter;
        this.forColorCodeNr = stockLogo.clampToColor;
        this.stockLogoID = parseInt(stockLogo.stockLogoID, 10);
        this.sizes = PartPatternContainer.getSizes(stockLogo);
        // this.setSizeStepNrs();
        this.taskCounter = new TaskCounter(this, () => {}, () => PartPatternContainer.setShaders());
        this.taskCounter.addTasks(this.getDroppableParts().length);
        this.insertTargetSize = stockLogo.targetSizeCM || stockLogo.standardSizeCM;
        PartPatternContainer.addPendingTasksToParts(this.getDroppableParts());
        this.patternAnker = new PatternAnkerContainer();
        this.patternAnker.extractAnkerFromParts(droppablePartGetter()); //, resourceManager.getResourceByName("patternAnkerLoaded")

        this.originalSVG = stockLogo.originalSVG || "";
        this.colors = stockLogo.colors;

        const currentSVG = stockLogo.currentSVG !== null && stockLogo.currentSVG !== "" ? stockLogo.currentSVG : null;
        if (currentSVG) {
            this.loadImageObject(currentSVG);
        } else {
            this.getOriginalSVG(true);
        }
    }

    public broadcastPreviewSVG() {
        EventVerteiler.broadcast("PreviewSVGCreatedEvent", {svg:this.createVorschauSVG(), colorCodeNr:this.forColorCodeNr});
    }

    private static getSizes(stockLogo:StockLogo) {
        if([stockLogo.maxSizeCM, stockLogo.minSizeCM, stockLogo.standardSizeCM].filter(v=>typeof(v)=== "undefined").length>0) {
            logIfDebug("sizes not set for pattern " + stockLogo.stockLogoID);
        }
        return {min:stockLogo.minSizeCM|| 3, max:stockLogo.maxSizeCM||30, standard:stockLogo.standardSizeCM || 10};
    }

    private static addPendingTasksToParts(droppableParts:OwayoKonfiPart[]) {
        droppableParts.forEach(p => p.pendingTasks.addTasks(1));
    }

    private static setShaders() {
        let part;
        for (part in globalsObject.owayoJSViewer.modelParts) {
            globalsObject.owayoJSViewer.modelParts[part].handleShader = HandleShaderCreator.createHandleShader(globalsObject.owayoJSViewer.modelParts[part]);
            ShaderCreator.createShaders(globalsObject.owayoJSViewer.modelParts[part], globalsObject.owayoJSViewer.getPatterns(part));
        }
    }

    getOriginalSVG(initializeFromVorbelegung) {
        globalsObject.stockLogoStore.getOriginalSVG(this.stockLogoID).then(data => this.svgLoaded(data, initializeFromVorbelegung));
    }

    private svgLoaded(data: StockLogoFromBackend, initializeFromVorbelegung) {
        this.originalSVG = data.svg;
        this.colors = data.colorCodes
        if (initializeFromVorbelegung) {
            this.setColorValuesFromVorbelegung();
        }
        this.createCurrentSVG();
    }

    private setColorValuesFromVorbelegung() {
        this.colors = this.colors.map(function (color) {
            color.colorIntValue = color.vorbelegung;
            return color;
        });
    }

    private static replaceClassesWithUUIDs(svgWithreplacedColors, forColorCodeNr):string {
        const classes = svgWithreplacedColors.matchAll(/class=["'](.*?)["']/g);
        for(const match of classes) {
            const replacement = match[1]+"_"+forColorCodeNr;
            const classDefinitionRegex = new RegExp("\."+match[1]+"\\s*{", "g");
            svgWithreplacedColors=svgWithreplacedColors.replaceAll(classDefinitionRegex, "."+replacement+" {");
            const classUsageRegex = new RegExp("class=[\"']"+match[1]+"[\"']", "g")
            svgWithreplacedColors=svgWithreplacedColors.replaceAll(classUsageRegex, "class=\""+replacement+"\"");
        }
        return svgWithreplacedColors;
    }

    public static fillSVGWithColors(svgWithOriginalColors:string, colors:ChromoLogoColor[], forColorCodeNr:number) {
        const regexString = colors.map(c=>c.colorCode).join("|");
        const regex = new RegExp(regexString, "gim");
        return PartPatternContainer.replaceClassesWithUUIDs(svgWithOriginalColors.replace(regex, function(match) {
            const color = colors.find(c=>c.colorCode.toUpperCase() === match.toUpperCase());
            return ColorUtils.decToHexWithPoundsign(color.colorIntValue);
        }), forColorCodeNr);
    }

    createVorschauSVG() {
        return PartPatternContainer.fillSVGWithColors(this.vorschauSVG, this.colors, this.forColorCodeNr);
    }

    createCurrentSVG() {
        const svg = PartPatternContainer.fillSVGWithColors(this.originalSVG, this.colors, this.forColorCodeNr);
        this.loadImageObject(svg);
    }

    static createMatrixAbsCanvasFromAbsUV(scaling: Vector2, partStauchungsFaktor, textureSize: Vector2, translationAbsolut: Vector2): THREE.Matrix3 {
        const scalingX = 1 / scaling.x / partStauchungsFaktor;
        const scalingY = 1 / scaling.y;
        const matrix = new THREE.Matrix3();

        matrix.set(
            scalingX,      0,scalingX * (-translationAbsolut.x) + 0.5 * textureSize.x,
            0,      scalingY,scalingY * (-translationAbsolut.y) + 0.5 * textureSize.y,
            0,         0,1
        );
        return matrix;
    }

    loadImageObject(svg: string) {
        const $this = this,
            canvas: HTMLCanvasElement = document.createElement('canvas');
        canvas.width = CONSTANTS.CHROMOLOGOCANVASWIDTH*1.1;
        canvas.height = CONSTANTS.CHROMOLOGOCANVASWIDTH*1.1;
        svg = this.replaceCmDimesionsWithPixelDimensions(svg);
        const v = Canvg.fromString(
            canvas.getContext("2d") as CanvasRenderingContext2D,
            svg,
            {
                ignoreMouse: true,
                ignoreAnimation: true,
                // useCORS: true,
                // noRenderLoop: true,
            }
        );
        v.start();
        const imageObj = new Image();
        imageObj.onload = function () {
            $this.imageObjectLoaded(imageObj);
            EventVerteiler.broadcast("ChromoLogoImageCreatedEvent", {image: this, isPattern:true});
        };
        imageObj.onerror = function () {
            warnIfDebug("could not Load Logo Image");
            // $this.viewerTaskFinished();
        };
        imageObj.src = canvas.toDataURL("image/png");
    }

    private replaceCmDimesionsWithPixelDimensions(svg: string) {
        function getDim(svg, dim:"width"|"height") {
            const match = svg.match(dim +"=\"(.*?)\"");
            return  match !== null ? parseFloat(match[1]) : null
        }

        const width = getDim(svg, "width");
        const height = getDim(svg, "height");
        if (width !== null && height !== null) {
            if (width > height) {
                const ratio = CONSTANTS.CHROMOLOGOCANVASWIDTH / width;
                svg = svg.replace(/width=".*?"/, "width=\"" + CONSTANTS.CHROMOLOGOCANVASWIDTH + "px\"");
                const newHeight = height * ratio;
                svg = svg.replace(/height=".*?"/, "height=\"" + newHeight + "px\"");
            } else {
                const ratio = CONSTANTS.CHROMOLOGOCANVASWIDTH / height;
                svg = svg.replace(/height=".*?"/, "height=\"" + CONSTANTS.CHROMOLOGOCANVASWIDTH + "px\"");
                const newWidth = Math.floor(width * ratio);
                svg = svg.replace(/width=".*?"/, "width=\"" + newWidth + "px\"");
            }
        }
        return svg;
    }

    private imageObjectLoaded(imageObj: HTMLImageElement) {
        this.clonedPatterns = [];
        this.patterns = this.getDroppableParts().map(
            (part: OwayoKonfiPart) => new PartPattern(this.getPartPatternConstructorArguments(part))
        );
        this.patterns.forEach((p: PartPattern) => p.imageObjectLoaded(imageObj));
    }

    private static flipRelativeYComponent = (v:Vector2)=>new Vector2(v.x, 1-v.y);

    private getPatternTranslation(part:OwayoKonfiPart) {
        if(this.patternAnker.getPosition(part.name) !== null) {
            return Vector2.multiplyComponents(PartPatternContainer.flipRelativeYComponent(this.patternAnker.getPosition(part.name)), part.textureSize);
        }
        return Vector2.multiplyComponents(part.textureSize, new Vector2(0.5, 0.5));
    }

    private getPartPatternConstructorArguments(part: OwayoKonfiPart) {
        return {
            patternContainer:this,
            translation: this.getPatternTranslation(part),
            rotation: 0,
            insertTargetSize: this.insertTargetSize,
            clampToColor: this.forColorCodeNr,
            parent: part,
            allowDelete: false,
            allowDrag: false,
            allowResize: false,
            isPattern: true,
            type: SelObTypes.PATTERN,
            id: createGUID(),
        }
    }

    getPatterns(partname: string): PartPattern[] {
        return this.patterns.concat(this.clonedPatterns).filter(pattern => pattern.getParentPartName() === partname);
    }

    public getColorHexValue(colorCodeInPattern) {
        const color = arrayElementByKeyValue(this.colors, "colorCode", colorCodeInPattern);
        return ColorUtils.decToHex((color as ChromoLogoColor).colorIntValue);
    }

    public setColorValue(colorCode: string, colorHexValue: string) {
        const color = arrayElementByKeyValue(this.colors, "colorCode", colorCode);
        (color as ChromoLogoColor).colorIntValue = ColorUtils.hexToDec(colorHexValue);
        PartPatternContainer.addPendingTasksToParts(this.getDroppableParts());
        this.createCurrentSVG();
    }

    public setColorValueFromFarbGedaechtnis(farbgedaechtnis:Patternfarbgedaechtnis) {
        const obergrenze = Math.min(this.colors.length, farbgedaechtnis.colorIntValuesOrderedByfarbnummerNachFarbAnteil.length)
        for(let i=0; i < obergrenze; i++) {
            this.colors[i].colorIntValue = farbgedaechtnis.colorIntValuesOrderedByfarbnummerNachFarbAnteil[i];
        }
        PartPatternContainer.addPendingTasksToParts(this.getDroppableParts());
        this.createCurrentSVG();
    }

    private static sendNewInsertTargetSize(colorCodeNrOnEntwurf, newSize, oldSize:number) {
        EventVerteiler.broadcast(PATTERN_EVENTNAMES.SIZE_CHANGED,
            {
                colorCodeOnEntwurf: globalsObject.controller.getColorCodeFromColorCodeNr(colorCodeNrOnEntwurf),
                newSize:newSize,
                oldSize:oldSize
            }
        );
    }
    private insertTargetSizeIsMax = ()=>this.insertTargetSize === this.sizes.max;
    private insertTargetSizeIsMin = ()=>this.insertTargetSize === this.sizes.min;

    private broadcastInsertSizeExtremaEvents() {
        if(this.insertTargetSizeIsMax()) {
            EventVerteiler.broadcast(PATTERN_EVENTNAMES.MAX_SIZE_REACHED, this.forColorCodeNr);
        }
        if(this.insertTargetSizeIsMin()) {
            EventVerteiler.broadcast(PATTERN_EVENTNAMES.MIN_SIZE_REACHED, this.forColorCodeNr);
        }
    }


    changeInsertTargetSizeInDirection(plusMinus:PlusMinus) {
        const oldSize = this.insertTargetSize;
        this.insertTargetSize = this.sizeStepsContainer.getNewSizeInDirection(this.insertTargetSize, plusMinus);
        this.broadcastInsertSizeExtremaEvents();
        PartPatternContainer.sendNewInsertTargetSize(this.forColorCodeNr, this.insertTargetSize, oldSize);
        this.clonedPatterns = [];
        this.patterns.forEach(p=>{
            p.setTargetSize(this.insertTargetSize);
            p.scaling = p.getScalingForTargetSize();
        });

        PartPatternContainer.setShaders();
    }

    changeInserttargetSizeToStepNr(stepNr) {
        const oldSize = this.insertTargetSize;
        this.insertTargetSize = this.sizeStepsContainer.getTargetWidthCMForStepNr(stepNr);
        this.broadcastInsertSizeExtremaEvents();
        PartPatternContainer.sendNewInsertTargetSize(this.forColorCodeNr, this.insertTargetSize, oldSize);
        this.clonedPatterns = [];
        this.patterns.forEach(p=>{
            p.setTargetSize(this.insertTargetSize);
            p.scaling = p.getScalingForTargetSize();
        });

        PartPatternContainer.setShaders();
    }

    public getSizeStepNumber = ()=>this.sizeStepsContainer.getSizeStepNumber(this.insertTargetSize);

    setColorsToColorVersion(colors:StockLogoColorVersionColor[]) {
        this.colors.forEach(function(c,i) {
            c.colorIntValue = colors[i].colorIntValue;
        });
        EventVerteiler.broadcast("patternColorVersionChangedEvent", {colorcodeNr:this.forColorCodeNr, colors:this.colors});
        PartPatternContainer.addPendingTasksToParts(this.getDroppableParts());
        this.createCurrentSVG();
        EventVerteiler.broadcast("broadcastUsedColorsEvent");
    }

    getStockLogoID() {
        return this.stockLogoID;
    }
}
